import React, { memo, useState,useEffect } from "react";

import { Row ,Col,Card,Button,Modal} from 'react-bootstrap';

import Details from "components/FullTest/MockOperations/SpeakingWritingDirectory/Details";
import SelfIntro from "components/FullTest/MockOperations/SpeakingWritingDirectory/SelfIntro";
import Questions from "components/FullTest/MockOperations/Questions";
import { useSelector } from 'react-redux';
import NetworkManager from './NetworkManager';
import FullScreen from "assets/images/FullScreen.png";
import DarkMode from "assets/images/DarkMode.png";
import InfoImage from "assets/images/info.png";
import ExitFullScreen from "assets/images/ExitFullScreen.png";
import LightMode from "assets/images/LightMode.png";
import { toggleFullScreen, toggleTheme, isFullScreen, isDarkMode } from "util/helper";

const SpeakingAndWriting = memo( function SpeakingAndWriting({
	mockData, questions, setSection, pending, localPending
}) {


	console.log("S&W localPending",localPending);
	
	
    //  console.log(mockData,questions,setSection,pending);
	// Flag: 1 => Section Deatils.
	// Flag: 2 => Self Intro.
	// Flag: 3 => Questions.
	const [flag, setFlag] = useState(pending === 1 ? 3 : 1);
	const [startFlag, setStartFlag] = useState(false);
	const [currQ, setCurrQ] = useState(-1);
    const intStatus = useSelector((state) => state.intStatus);
	const [isOnline, setIsOnline] = useState(true);
	const [, forceUpdate] = useState();

    useEffect(() => {
    const connection = typeof intStatus === "undefined" ? true : intStatus;
    setIsOnline(connection);
    
    if (connection) {
      NetworkManager.retryFailedRequests();
    }
  }, [intStatus]);

	const nextButton = (e) => {
		if (flag === 2) {
			setStartFlag(true);
		} else {
			setFlag(prev => (prev + 1));
			setCurrQ(0);
		}
	};

	const sectionTime = () => {
		return pending ? mockData.time : (parseInt(mockData.mock.speaking_time) + parseInt(mockData.mock.writting_time));
	};

	const toggleYes = () => {
		setStartFlag(prev => false);
		setFlag(prev => (prev + 1));
	};
	return (
		<>
		  {/* {!isOnline && (
        <div className="network-warning">
          <i className="fa fa-wifi"></i>
          Connection lost. Your progress is saved and will sync when reconnected.
        </div>
      )} */}
			{/* {(flag === 1 || flag === 2) &&
				<div className="content questionsArea deviceTestPage">
					<Row>
						<Col xs={12}>
							<Card>
								<Card.Body>
									{flag === 1 &&
										<Details
											user={mockData.user_data}
											totalQuestions={questions.length}
											time={(parseInt(mockData.mock.speaking_time) + parseInt(mockData.mock.writting_time))}
										/>
									}

									{flag === 2 &&
										<SelfIntro nextButton={nextButton} />
									}
								</Card.Body>
							</Card>
						</Col>

						<Col xs={12}>
							<div className="bottomBtns">
								<Row>
									<Col xs={9}>
										
									</Col>
									<Col xs={3}>
										<Button
											variant="primary"
											onClick={nextButton}
											size="xs"
										>NEXT</Button>
									</Col>
								</Row>
							</div>
						</Col>
					</Row>
				</div>
			} */}

			{(flag === 1 || flag === 2) &&
  <div className="content questionsArea deviceTestPage old-design p-0 test_width mock-container" id="test-card">
    <Row>
      <Col xs={12}>
        {/* TestHeader - Same as Questions component */}
        <Row className="m-0 test_width">
          <Row
            className="d-flex justify-content-between align-items-center w-100 h-50 mock-header-bg"
            style={{
            //   backgroundColor: "#BFBABB",
              height: "40px !important",
            }}
          >
            <Col style={{ width: "fit-content", padding: "0" }}>
              <Card.Title tag="h4" className="m-0 mx-2">
                Language Academy - {mockData.mock.title}
              </Card.Title>
            </Col>
          </Row>
          <Row
            style={{
              backgroundColor: "#0081A4",
              minHeight: "40px",
            }}
            className="d-flex justify-content-end align-items-center px-4"
          >
            <div className="d-flex justify-content-end gap-3">
              {/* <i className="fa fa-expand text-white" style={{ cursor: "pointer" }}></i>
              <i className="fa fa-moon-o text-white" style={{ cursor: "pointer" }}></i> */}
				<img
				  src={isFullScreen() ? ExitFullScreen : FullScreen}
				  onClick={() => {
					toggleFullScreen();
					setTimeout(() => {
						forceUpdate({});
					}, 100);
				  }}
				  alt={isFullScreen() ? "Exit Full Screen" : "Full Screen"}
				  className="toggle-icons"
				/>
				<img
				  src={isDarkMode() ? LightMode : DarkMode}
				  onClick={() => {
					toggleTheme();
					forceUpdate({});
				  }}
				  alt={isDarkMode() ? "Light Mode" : "Dark Mode"}
				  className="toggle-icons"
				/>			  
            </div>
          </Row>
        </Row>

        {/* Content with proper padding */}
        <div style={{ padding: "20px 40px 40px", paddingBottom: "80px" }}>
          {flag === 1 && (
            <Details
              user={mockData.user_data}
              totalQuestions={questions.length}
              time={(parseInt(mockData.mock.speaking_time) + parseInt(mockData.mock.writting_time))}
            />
          )}
          {flag === 2 && <SelfIntro nextButton={nextButton} />}
        </div>
      </Col>

      {/* BottomBtns - Same as Questions component */}
      <Col xs={12}>
        <div className="bottomBtns fixed-bottom-row mock-header-gap">
          <Row className="align-items-center mx-0 gap-1 fixed-bottom-row w-100 mock-header-gap">
            {/* <Col xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "15%",minHeight: "50px" }}></Col> */}
            <Col className="text-center py-2 z-3 mock-bottom-btn-toggle flex-grow-1" style={{ minHeight: "50px" }}></Col>
            <Col xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "20%",minHeight: "50px" }}>
              <Button
                variant="primary"
                onClick={nextButton}
                size="xs"
                className="mock-btn bottomBtnFont d-flex align-items-center"
              >
                NEXT
              </Button>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  </div>
}

			{flag === 3 &&
				<Questions
					mockData={mockData}
					mock={mockData.mock}
					time={sectionTime()}
					questions={questions}
					setSection={setSection}
					pending={pending}
					localPending={localPending}
					skip={1}
					isOnline={isOnline}
				/>
			}

			{/* <Modal show={startFlag} size="sm">
				<Modal.Body>
					<div>Do you want to go to next Question?</div>
				</Modal.Body>

				<Modal.Footer>
					<Button
						variant="secondary"
						className="modalCloseBtn"
						onClick={toggleYes}
					>Yes</Button>

					<Button
						variant="secondary"
						className="modalCloseBtn"
						onClick={() => setStartFlag(prev => false)}
					>No</Button>
				</Modal.Footer>
			</Modal> */}
			<Modal show={startFlag} size="md" centered contentClassName="mock-container">
			<Modal.Header style={{ padding: "0px" }} className="mock-popup-header">
				<div className="d-flex justify-content-end align-items-center p-2">
				<button onClick={()=> setStartFlag(prev => false)} className="modal-close-btn" >
					×
				</button>
				</div>
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex gap-2 align-items-center mock-resource-text">
				<div className="d-flex justify-content-center align-items-center">
					<img
					src={InfoImage}
					alt="Information"
					style={{
						height: "40px",
						width: "30px",
						objectFit: "contain",
						display: "block",
					}}
					/>
				</div>{" "}Do you want to go to next Question?
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button
				color="secondary"
				className="mock-test-modal-button"
				onClick={toggleYes}
				>
				Yes
				</Button>
				<Button
				color="secondary"
				className="mock-test-modal-button"
				onClick={()=> setStartFlag(prev => false)}
				>
				No
				</Button>
			</Modal.Footer>
			</Modal>
		</>		
	);
});

export default SpeakingAndWriting;